import { webpORpng } from ".";

// Skip external asset preloading; we rely on runtime placeholders.
export const urls: string[] = [];
